import { API } from "./api";

export const getAllCompanies = () => API.get(`/companies`);
export const getCompanyById = (id) => API.get(`/companies/${id}`);
export const addCompany = (company) => API.post(`/companies/admin`, company);
export const deleteCompany = (companyId) =>
  API.delete(`/companies/${companyId}`);

export const updateCompany = (id, companies) =>
  API.put(`companies/admin/${id}`, companies);
